import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FETCH_SEO_META_REQUEST, FETCH_SEO_META_SUCCESS, FETCH_SEO_META_FAILURE, FETCH_SEO_LINKS_BLOCKS_REQUEST, FETCH_SEO_LINKS_BLOCKS_SUCCESS, FETCH_SEO_LINKS_BLOCKS_FAILURE, FETCH_SEO_TEXTS_BLOCKS_REQUEST, FETCH_SEO_TEXTS_BLOCKS_SUCCESS, FETCH_SEO_TEXTS_BLOCKS_FAILURE } from 'actionTypes';
import createReducer from './createReducer';
var initialState = {};
var seo = createReducer(initialState, (_createReducer = {}, _defineProperty(_createReducer, FETCH_SEO_META_REQUEST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url] || {}), {}, {
    meta: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: true,
      isRequestFailed: false,
      isLoaded: false
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_META_SUCCESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url]), {}, {
    meta: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: false,
      isRequestFailed: false,
      isLoaded: true
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_META_FAILURE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url]), {}, {
    meta: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: false,
      isRequestFailed: true,
      isLoaded: false
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_LINKS_BLOCKS_REQUEST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url] || {}), {}, {
    linksBlocks: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: true,
      isRequestFailed: false,
      isLoaded: false
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_LINKS_BLOCKS_SUCCESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url]), {}, {
    linksBlocks: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: false,
      isRequestFailed: false,
      isLoaded: true
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_LINKS_BLOCKS_FAILURE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url]), {}, {
    linksBlocks: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: false,
      isRequestFailed: true,
      isLoaded: false
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_TEXTS_BLOCKS_REQUEST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url] || {}), {}, {
    texts: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: true,
      isRequestFailed: false,
      isLoaded: false
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_TEXTS_BLOCKS_SUCCESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url]), {}, {
    texts: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: false,
      isRequestFailed: false,
      isLoaded: true
    })
  })));
}), _defineProperty(_createReducer, FETCH_SEO_TEXTS_BLOCKS_FAILURE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, state[action.payload.url]), {}, {
    texts: _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: false,
      isRequestFailed: true,
      isLoaded: false
    })
  })));
}), _createReducer));
export default seo;